// Module
var code = "<template> <section id=\"transitional-page-view\"> <iframe id=\"transitionalFrame\" aria-label=\"${ariaLabel}\" title=\"${pageTitle}\"></iframe> </section> </template> ";
// Exports
module.exports = code;